module.exports = __webpack_public_path__ + "static/img/list-icon-monthly.fc4f77f.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build922/assets/image/vip/list-icon-monthly.png
// module id = N3as
// module chunks = 0 1 2 3 4 5 6